export const audioLanguage = [
  { label: "— Popular —", value: "— Popular —", disabled: true },
  { value: "English", label: "English 🇺🇸" },
  { value: "English (US)", label: "English (US) 🇺🇸" },
  { value: "English (UK)", label: "English (UK) 🇬🇧", selected: true },
  { value: "Spanish", label: "Spanish 🇪🇸" },
  { value: "Portuguese", label: "Portuguese 🇵🇹" },
  { value: "French", label: "French 🇫🇷" },
  { value: "Italian", label: "Italian 🇮🇹" },
  { value: "German", label: "German 🇩🇪" },
  { value: "Dutch", label: "Dutch 🇳🇱" },
  { value: "Polish", label: "Polish 🇵🇱" },
  { value: "Danish", label: "Danish 🇩🇰" },
  { value: "Japanese", label: "Japanese 🇯🇵" },
  { value: "Korean", label: "Korean 🇰🇷" },
  { value: "Hungarian", label: "Hungarian 🇭🇺" },
  { value: "Czech", label: "Czech 🇨🇿" },
  { value: "Chinese", label: "Chinese 🇨🇳" },
  { value: "Hebrew", label: "Hebrew 🇮🇱" },
  {
    label: "— More High Accuracy Languages —",
    value: "— More High Accuracy Languages —",
    disabled: true,
  },
  { value: "Afrikaans", label: "Afrikaans 🇿🇦" },
  { value: "Arabic", label: "Arabic 🇸🇦" },
  { value: "Armenian", label: "Armenian 🇦🇲" },
  { value: "Azerbaijani", label: "Azerbaijani 🇦🇿" },
  { value: "Belarusian", label: "Belarusian 🇧🇾" },
  { value: "Bosnian", label: "Bosnian 🇧🇦" },
  { value: "Bulgarian", label: "Bulgarian 🇧🇬" },
  { value: "Catalan", label: "Catalan 🇪🇸" },
  { value: "Chinese (Simplified)", label: "Chinese (Simplified) 🇨🇳" },
  { value: "Chinese (Traditional)", label: "Chinese (Traditional) 🇹🇼" },
  { value: "Croatian", label: "Croatian 🇭🇷" },
  { value: "Estonian", label: "Estonian 🇪🇪" },
  { value: "Finnish", label: "Finnish 🇫🇮" },
  { value: "Galician", label: "Galician 🇪🇸" },
  { value: "Greek", label: "Greek 🇬🇷" },
  { value: "Hindi", label: "Hindi 🇮🇳" },
  { value: "Icelandic", label: "Icelandic 🇮🇸" },
  { value: "Indonesian", label: "Indonesian 🇮🇩" },
  { value: "Kannada", label: "Kannada 🇮🇳" },
  { value: "Kazakh", label: "Kazakh 🇰🇿" },
  { value: "Latvian", label: "Latvian 🇱🇻" },
  { value: "Lithuanian", label: "Lithuanian 🇱🇹" },
  { value: "Macedonian", label: "Macedonian 🇲🇰" },
  { value: "Malay", label: "Malay 🇲🇾" },
  { value: "Maori", label: "Maori 🇳🇿" },
  { value: "Marathi", label: "Marathi 🇮🇳" },
  { value: "Nepali", label: "Nepali 🇳🇵" },
  { value: "Norwegian", label: "Norwegian 🇳🇴" },
  { value: "Persian", label: "Persian 🇮🇷" },
  { value: "Romanian", label: "Romanian 🇷🇴" },
  { value: "Russian", label: "Russian 🇷🇺" },
  { value: "Serbian", label: "Serbian 🇷🇸" },
  { value: "Slovak", label: "Slovak 🇸🇰" },
  { value: "Slovenian", label: "Slovenian 🇸🇮" },
  { value: "Swahili", label: "Swahili 🇹🇿" },
  { value: "Swedish", label: "Swedish 🇸🇪" },
  { value: "Tagalog", label: "Tagalog 🇵🇭" },
  { value: "Tamil", label: "Tamil 🇮🇳" },
  { value: "Thai", label: "Thai 🇹🇭" },
  { value: "Turkish", label: "Turkish 🇹🇷" },
  { value: "Ukrainian", label: "Ukrainian 🇺🇦" },
  { value: "Urdu", label: "Urdu 🇵🇰" },
  { value: "Vietnamese", label: "Vietnamese 🇻🇳" },
  { value: "Welsh", label: "Welsh 🇬🇧" },
  {
    label: "— Other Languages —",
    value: "— Other Languages —",
    disabled: true,
  },
  { value: "Albanian", label: "Albanian 🇦🇱" },
  { value: "Amharic", label: "Amharic 🇪🇹" },
  { value: "Assamese", label: "Assamese 🇮🇳" },
  { value: "Bashkir", label: "Bashkir 🇷🇺" },
  { value: "Basque", label: "Basque 🇪🇸" },
  { value: "Bengali", label: "Bengali 🇮🇳" },
  { value: "Breton", label: "Breton 🇫🇷" },
  { value: "Burmese", label: "Burmese 🇲🇲" },
  { value: "Castilian", label: "Castilian 🇪🇸" },
  { value: "Faroese", label: "Faroese 🇫🇴" },
  { value: "Flemish", label: "Flemish 🇧🇪" },
  { value: "Georgian", label: "Georgian 🇬🇪" },
  { value: "Gujarati", label: "Gujarati 🇮🇳" },
  { value: "Haitian", label: "Haitian 🇭🇹" },
  { value: "Haitian Creole", label: "Haitian Creole 🇭🇹" },
  { value: "Hausa", label: "Hausa 🇳🇬" },
  { value: "Hawaiian", label: "Hawaiian 🇺🇸" },
  { value: "Javanese", label: "Javanese 🇮🇩" },
  { value: "Khmer", label: "Khmer 🇰🇭" },
  { value: "Lao", label: "Lao 🇱🇦" },
  { value: "Latin", label: "Latin 🇻🇦" },
  { value: "Lingala", label: "Lingala 🇨🇩" },
  { value: "Luxembourgish", label: "Luxembourgish 🇱🇺" },
  { value: "Malagasy", label: "Malagasy 🇲🇬" },
  { value: "Malayalam", label: "Malayalam 🇮🇳" },
  { value: "Maltese", label: "Maltese 🇲🇹" },
  { value: "Moldovan", label: "Moldovan 🇲🇩" },
  { value: "Mongolian", label: "Mongolian 🇲🇳" },
  { value: "Myanmar", label: "Myanmar 🇲🇲" },
  { value: "Nynorsk", label: "Nynorsk 🇳🇴" },
  { value: "Occitan", label: "Occitan 🇫🇷" },
  { value: "Pashto", label: "Pashto 🇦🇫" },
  { value: "Punjabi", label: "Punjabi 🇮🇳" },
  { value: "Sanskrit", label: "Sanskrit 🇮🇳" },
  { value: "Shona", label: "Shona 🇿🇼" },
  { value: "Sindhi", label: "Sindhi 🇮🇳" },
  { value: "Sinhala", label: "Sinhala 🇱🇰" },
  { value: "Somali", label: "Somali 🇸🇴" },
  { value: "Sundanese", label: "Sundanese 🇮🇩" },
  { value: "Tajik", label: "Tajik 🇹🇯" },
  { value: "Tatar", label: "Tatar 🇷🇺" },
  { value: "Telugu", label: "Telugu 🇮🇳" },
  { value: "Tibetan", label: "Tibetan 🇮🇳" },
  { value: "Turkmen", label: "Turkmen 🇹🇲" },
  { value: "Uzbek", label: "Uzbek 🇺🇿" },
  { value: "Valencian", label: "Valencian 🇪🇸" },
  { value: "Yiddish", label: "Yiddish 🇮🇱" },
  { value: "Yoruba", label: "Yoruba 🇳🇬" },
];

export const fonts = [
  { value: "Roboto", label: "Roboto" },
  { value: "Inter", label: "Inter" },
  { value: "Permanent Marker", label: "Permanent Marker" },
  { value: "Poppins", label: "Poppins" },
  // { value: "Tagesschrift", label: "Tagesschrift" },
  { value: "Raleway", label: "Raleway" },
  { value: "Heebo", label: "Heebo" },
  { value: "Sansation", label: "Sansation" },
];

export const positions = [
  { value: "Top-Center", label: "Top" },
  { value: "Middle-Center", label: "Center" },
  { value: "Bottom-Center", label: "Bottom" },
];

// Define template types
export const TEMPLATE_TYPES = {
  TEXT: "TEXT",
  TEXT_BACKGROUND: "TEXT_BACKGROUND",
  WORD: "WORD",
  WORD_BACKGROUND: "WORD_BACKGROUND",
  TEXT_ROLLOVER: "TEXT_ROLLOVER",
  TEXT_ROLLOVER_BACKGROUND: "TEXT_ROLLOVER_BACKGROUND",
  TEXT_SINGLE: "TEXT_SINGLE",
  TEXT_SINGLE_BACKGROUND: "TEXT_SINGLE_BACKGROUND",
};
